@let reasons = siteWorkflow.deleteSiteTooltips();

<aux-button
  icon="Trash"
  label="Delete Site"
  variant="negative"
  [disabled]="
    siteWorkflow.disabledUpdateSiteCostUI() || !siteWorkflow.permissions().userHasSitePermission
  "
  [auxTooltip]="reasons.length === 1 ? reasons[0] : ''"
  [template]="reasons.length > 1 ? cantDeleteSiteTooltip : undefined"
  (click)="deleteSite()"
/>

<ng-template #cantDeleteSiteTooltip>
  <aux-errors-tooltip [errors]="reasons" />
</ng-template>
